module.exports = __webpack_public_path__ + "img/left-chevron.dc548700.svg";